var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.063,
    height: 24,
    viewBox: "0 0 22.063 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification",
    transform: "translate(-20.66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_687",
    "data-name": "Group 687",
    transform: "translate(20.66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M191.132,469.361a3.313,3.313,0,0,0,6.083,0c-.962.047-1.962.079-3.041.079S192.094,469.408,191.132,469.361Z",
    transform: "translate(-183.141 -447.36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M42.28,16.92c-1.265-1.6-3.389-4.732-3.389-7.8a7.237,7.237,0,0,0-4.8-6.785,2.4,2.4,0,0,0-4.8,0,7.237,7.237,0,0,0-4.8,6.785c0,3.069-2.123,6.2-3.389,7.8a2.037,2.037,0,0,0-.348,1.883,1.981,1.981,0,0,0,1.331,1.306,27.1,27.1,0,0,0,5.7.884c1.2.081,2.492.128,3.9.128s2.7-.047,3.9-.128a27.116,27.116,0,0,0,5.7-.884,1.98,1.98,0,0,0,1.33-1.306A2.04,2.04,0,0,0,42.28,16.92Z",
    transform: "translate(-20.66)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.f991002e96a09d9587b75516b2c4c49d.svg";
export { ForwardRef as ReactComponent };